<template>
  <div class="user-box">
    <div class="user-top">
        <h3>{{userName}}</h3>
        <div>{{lvl}}</div>
    </div>
    <div class="user-nav">
      <a href="/content/certificate">
        <span><i class="iconfont iconzhengshu"></i>会员证书</span>
        <i class="iconfont iconxiayibu"></i>
      </a>
      <a href="/content/info">
        <span><i class="iconfont iconzhengjian"></i>个人信息</span>
        <i class="iconfont iconxiayibu"></i>
      </a>
      <a href="/content/account">
        <span><i class="iconfont iconhuiyuanguanli"></i>账号管理</span>
        <i class="iconfont iconxiayibu"></i>
      </a>
      <a href="javascript:void 0" @click="sginOut">
        <span><i class="iconfont icontuichu"></i>退出登录</span>
        <i class="iconfont iconxiayibu"></i>
      </a>
    </div>
    <bottomNav :navIndex="navIndex"/>
  </div>
</template>

<script>
  import bottomNav from '../components/Nav'
  import store from "../../store";
  export default {
    name: "User",
    data(){
      return {
        navIndex:2,
        userName:'',
        lvl:''
      }
    },
    created() {
      this.userName = this.$store.state.user.nickname
      this.lvl = this.$store.state.user.lvlName
    },
    methods:{
      sginOut(){
        sessionStorage.clear()
        localStorage.clear()
        store.user = null
        window.location.href = '/phoneLogin'
      }
    },
    components:{
      bottomNav
    }
  }
</script>
<style scoped lang="scss">
  .user-box{
    .user-top{
      width: 100%;
      height: 235px;
      padding: 70px 0;
      background: url(../../assets/img/userbg.jpg) no-repeat top center;
      background-size: 100%;
      h3{
        text-align: center;
        font-size: 24px;
        color: #fff;
      }
      div{
        width: 80px;
        height: 24px;
        margin: 10px auto;
        text-align: center;
        line-height: 22px;
        color: #2b8ee3;
        background-color: #ffffff;
        border-radius: 9px;
        border: solid 1px #2b8ee3;
      }
    }
    .user-nav{
      padding: 20px;
      a{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        height: 55px;
        span{
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #333;
          i{
            display: block;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            background-color: #2b8ee3;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            margin-right: 10px;
          }
        }
        .iconxiayibu{
          color: #999;
        }
      }
    }
  }

</style>